import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'passwords',
  templateUrl: './passwords.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryPasswordsComponent implements OnInit {
  @Input() data;
  @Output() dPasswordsEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.dPasswordsEmitter.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.dPasswordsEmitter.emit({ status: 'backward' });
  }
}
